import { Box } from "@chakra-ui/react";
import React from "react";

const GlassyBox = ({ children, width }) => {
  return (
    <Box
      w={width}
      p="4"
      bg="blackAlpha.100"
      backdropFilter="auto"
      backdropBlur="4px"
      borderRadius="10px"
      color="#fff"
      boxShadow="inset 0 0 10px rgba(255, 255, 255, .5)"
      _hover={{ boxShadow: "0px 10px 15px 5px teal" }}
    >
      {children}
    </Box>
  );
};

export default GlassyBox;
